import React from "react";
import "./FallbackComponent.css";

export default function FallbackComponent() {
  const handleRefresh = () => {
    window.location.reload();
  };

  return (
    <div className="fallback-container">
      <div className="fallback-content">
        <div className="fallback-icon">⚠️</div>
        <h2>模块加载失败</h2>
        <p>抱歉，网络异常，无法加载所需模块，请尝试刷新页面</p>
        <button className="refresh-button" onClick={handleRefresh}>
          刷新页面
        </button>
      </div>
    </div>
  );
}